// @flow

import { Map, List } from 'immutable';
import {
    OPEN_DEFAULT,
    OPEN_VIDEO,
    OPEN_GALLERY,
    OPEN_MODEL,
    OPEN_RESOURCE,
    DEFAULT,
    VIDEO,
    GALLERY,
    SELECTED,
    RESOURCE,
    MODEL,
    OPEN_STREAM,
    STREAM,
    SET_SELECTED_TAB_NAME,
    SELECTED_TAB_NAME
} from './../types/modules';
import type { ModulesAction, Item } from './../types/modules';

import {
    SIGN_OUT,
} from './../types/auth';

const INITIAL_MAP = Map({
    [SELECTED]: DEFAULT,
    [SELECTED_TAB_NAME]: "projects"
});

const ModulesReducer = (state: Map<string, List<Item> | string> = INITIAL_MAP, action: ModulesAction) => {
    switch (action.type) {
        case OPEN_DEFAULT:
            return state
                .set(SELECTED, DEFAULT);

        case OPEN_VIDEO:
            return state
                .set(SELECTED, VIDEO);

        case OPEN_RESOURCE:
            return state
                .set(SELECTED, RESOURCE);

        case OPEN_GALLERY:
            return state
                .set(SELECTED, GALLERY);

        case OPEN_MODEL:
            return state
                .set(SELECTED, MODEL);

        case OPEN_STREAM:
            return state
                .set(SELECTED, STREAM);

        case SET_SELECTED_TAB_NAME:
            return state
                .set(SELECTED_TAB_NAME, action.selectedTabName);

        case SIGN_OUT:
            return INITIAL_MAP;

        default:
            return state;
    }
};

export default ModulesReducer;


// WEBPACK FOOTER //
// ./src/reducers/modules.jsx